import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <path d="M22.5,86.2C12.3,86.2,4,91,4,97s8.3,10.7,18.5,10.7S41,102.9,41,97,32.7,86.2,22.5,86.2Zm-5.1,17.6a14.2,14.2,0,0,1-4.7-8.9c-.7-6.9,5.9-7.4,10.5-6.7s8.2,5.9,9.3,11.9S21.9,107.6,17.4,103.8Z" />
            <circle cx="52" cy="95" r="4" />
        </svg>
    );
}
